import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/modals.css';
import { Button, Modal } from 'react-bootstrap';

interface props {
  showModal: boolean;
  closeModal: () => void;
}

export default function ResetPasswordConfirmation({
  showModal = false,
  closeModal,
}: props) {
  return (
    <>
      <Modal
        show={showModal}
        onHide={closeModal}
        contentClassName="ec-modal-content"
      >
        <Modal.Header className="ec-modal-header" closeButton>
          <Modal.Title className="ec-modal-title">
            An email has been sent to your inbox.
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer className="ec-modal-footer">
          <Button
            variant="primary"
            type="submit"
            className="ec-modal-reset-password"
            onClick={closeModal}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
